
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

/**
 * 웹파트를 추가/편집/삭제를 통해 관리하는 화면
 */
@Component({
    name: 'webpart-list-item',
})
export default class WebpartListItem extends Vue {
    @Prop({ type: Object, required: true }) webpart!: webpartv3.Webpart
    @Prop({ type: String, default: 'ko-KR'}) userLang!: string

    get size(): string {
        const { isFixedSize, columns, rows } = this.webpart
        if (isFixedSize) return `${columns} x ${rows}`
        else return this.$t('사용자지정').toString()
    }
}
